(function ($) {
  "use strict";

  const __Main = {
    sliders: new Set(),
    vanillaListeners: [],
    registerSlider(selector) {
      this.sliders.add(selector);
    },
    addVanillaListener(el, type, handler, options) {
      el.addEventListener(type, handler, options);
      this.vanillaListeners.push({ el, type, handler, options });
    },
    cleanup() {
      // destroy slick sliders
      this.sliders.forEach((sel) => {
        const $el = $(sel);
        if ($el.length && $el.hasClass('slick-initialized')) {
          try { $el.slick('unslick'); } catch (e) { /* ignore */ }
        }
      });
      // remove namespaced jquery events
      $(document).off('.mainjs');
      $(window).off('.mainjs');
      // remove vanilla listeners
      this.vanillaListeners.forEach(({ el, type, handler, options }) => {
        try { el.removeEventListener(type, handler, options); } catch (e) { /* ignore */ }
      });
      this.vanillaListeners = [];
      this.sliders.clear();
    }
  };

  $(document).ready(function () {

    const showRoutePreloader = function () {
      const activeRoutePreloader = $('.custom-route-page[style*="display: block"] .preloader').first();

      if (!activeRoutePreloader.length) {
        return;
      }

      activeRoutePreloader.stop(true, true).show().delay(250).fadeOut(400);
    };

    __Main.addVanillaListener(window, 'moto:route-change', function () {
      showRoutePreloader();
    });

    // ============== Mobile Nav Menu Dropdown Js Start =======================
    const windowWidth = $(window).width();

    $('.has-submenu').on('click.mainjs', function () {
      const thisItem = $(this);

      if (windowWidth < 992) {
        if (thisItem.hasClass('active')) {
          thisItem.removeClass('active')
        } else {
          $('.has-submenu').removeClass('active')
          $(thisItem).addClass('active')
        }

        const submenu = thisItem.find('.nav-submenu');

        $('.nav-submenu').not(submenu).slideUp(300);
        submenu.slideToggle(300);
      }

    });
    // ============== Mobile Nav Menu Dropdown Js End =======================

    // ===================== Scroll Back to Top Js Start ======================
    const progressPath = document.querySelector('.progress-wrap path');
    if (progressPath) {
      const pathLength = progressPath.getTotalLength();
      progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
      progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
      progressPath.style.strokeDashoffset = pathLength;
      progressPath.getBoundingClientRect();
      progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
      const updateProgress = function () {
        const scroll = $(window).scrollTop();
        const height = $(document).height() - $(window).height();
        const progress = pathLength - (scroll * pathLength / height);
        progressPath.style.strokeDashoffset = progress;
      }
      updateProgress();
      $(window).on('scroll.mainjs', updateProgress);
      const offset = 50;
      const duration = 550;
      jQuery(window).on('scroll.mainjs', function () {
        if (jQuery(this).scrollTop() > offset) {
          jQuery('.progress-wrap').addClass('active-progress');
        } else {
          jQuery('.progress-wrap').removeClass('active-progress');
        }
      });
      jQuery('.progress-wrap').on('click.mainjs', function (event) {
        event.preventDefault();
        jQuery('html, body').animate({ scrollTop: 0 }, duration);
        return false;
      })
    }
    // ===================== Scroll Back to Top Js End ======================

    // ========================== add active class to ul>li top Active current page Js Start =====================
    function dynamicActiveMenuClass(selector) {
      let FileName = window.location.pathname.split("/").reverse()[0];

      if (FileName === "" || FileName === "index.html") {
        selector.find("li.nav-menu__item.has-submenu").eq(0).addClass("activePage");
      } else {
        selector.find("li").removeClass("activePage");

        selector.find("li").each(function () {
          const anchor = $(this).find("a");
          if ($(anchor).attr("href") == FileName) {
            $(this).addClass("activePage");
          }
        });

        selector.children("li").each(function () {
          if ($(this).find(".activePage").length) {
            $(this).addClass("activePage");
          }
        });
      }
    }

    if ($('ul').length) {
      dynamicActiveMenuClass($('ul'));
    }
    // ========================== add active class to ul>li top Active current page Js End =====================

    // ========================== Select2 Js Start =================================
    if ($.fn.select2) {
      $('.js-example-basic-single').not('.select2-hidden-accessible').select2();
    }
    // ========================== Select2 Js End =================================

    const syncSearchOverlayState = function (isOpen) {
      $('body').toggleClass('search-overlay-open', isOpen);
      $('.search-icon')
        .toggleClass('activePage', isOpen)
        .attr('aria-label', isOpen ? 'Back' : 'Open search')
        .attr('title', isOpen ? 'Back' : 'Open search');

      $('.search-icon [data-search-toggle-icon]')
        .toggleClass('ph-magnifying-glass', !isOpen)
        .toggleClass('ph-arrow-left', isOpen);
    };

    $('.search-icon').on('click.mainjs', function () {
      const searchBox = $('.search-box');
      const willOpen = !searchBox.hasClass('active');

      searchBox.toggleClass('active', willOpen);
      syncSearchOverlayState(willOpen);
    });
    $('.search-box__close').on('click.mainjs', function () {
      $('.search-box').removeClass('active');
      syncSearchOverlayState(false);
    });
    // ========================== Select2 Js End =================================

    // ========================== Category Dropdown Responsive Js Start =================================
    $('.responsive-dropdown .has-submenus-submenu').on('click.mainjs', function () {

      const wWidth = $(window).width();
      if (wWidth < 992) {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).children('.submenus-submenu').slideUp();
        } else {
          $('.responsive-dropdown .has-submenus-submenu').removeClass('active');
          $('.responsive-dropdown .has-submenus-submenu').children('.submenus-submenu').slideUp();

          $(this).addClass('active');
          $(this).children('.submenus-submenu').slideDown();
        }
      }
    });
    // ========================== Category Dropdown Responsive Js End =================================

    // ========================== On Click Category menu show Js Start =================================
    $('.category__button').on('click.mainjs', function () {
      $('.responsive-dropdown').addClass('active');
      $('.side-overlay').addClass('show');
      $('body').addClass('scroll-hide-sm');
    });
    $('.side-overlay, .close-responsive-dropdown').on('click.mainjs', function () {
      $('.responsive-dropdown').removeClass('active');
      $('.side-overlay').removeClass('show');
      $('body').removeClass('scroll-hide-sm');
    });
    // ========================== On Click Category menu show Js End =================================

    // ========================== Set Language in dropdown Js Start =================================
    $('.selectable-text-list li').each(function () {
      const thisItem = $(this);

      thisItem.on('click.mainjs', function () {
        const listText = thisItem.text();
        thisItem.parent().parent().find('.selected-text').text(listText);
      });
    });
    // ========================== Set Language in dropdown Js End =================================

    // ========================= Banner Slider Js Start ==============
    $('.banner-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1000,
      dots: true,
      pauseOnHover: true,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      infinite: true,
    });
    __Main.registerSlider('.banner-slider');
    // ========================= Banner Slider Js End ===================

    // ========================= Category Js End ===================
    const categoryButtons = document.querySelectorAll('.category-button');

    if (categoryButtons && categoryButtons.length) {
      categoryButtons.forEach((categoryButton) => {
        const wrapper = categoryButton.closest('.menu-category-wrapper') || categoryButton.parentElement;
        const categoryDropdown = wrapper ? wrapper.querySelector('.category-dropdown') : null;

        const onCategoryButtonClick = function (event) {
          event.stopPropagation();
          categoryButton.classList.toggle('active');
          if (categoryDropdown) categoryDropdown.classList.toggle('active');
        };

        const onCategoryDropdownClick = function (event) {
          event.stopPropagation();
          categoryButton.classList.add('active');
          if (categoryDropdown) categoryDropdown.classList.add('active');
        };

        const onBodyClick = function () {
          categoryButton.classList.remove('active');
          if (categoryDropdown) categoryDropdown.classList.remove('active');
        };

        __Main.addVanillaListener(categoryButton, 'click', onCategoryButtonClick);
        if (categoryDropdown) __Main.addVanillaListener(categoryDropdown, 'click', onCategoryDropdownClick);
        __Main.addVanillaListener(document.querySelector('body'), 'click', onBodyClick);
      });
    }
    // ========================= Category Js End ===================
    // ========================= promotional-banner Slider Js Start ==============
    const $promotionalBannerSlider = $('.promotional-banner-slider');
    let promotionalBannerResumeTimer = null;
    const promotionalBannerCanAutoplay = function () {
      if (!$promotionalBannerSlider.length || !$promotionalBannerSlider.hasClass('slick-initialized')) return false;
      const slickInstance = $promotionalBannerSlider.slick('getSlick');
      return Boolean(slickInstance && slickInstance.options && slickInstance.options.autoplay);
    };

    const resumePromotionalBannerAfterDelay = function () {
      clearTimeout(promotionalBannerResumeTimer);
      promotionalBannerResumeTimer = setTimeout(function () {
        if (!$promotionalBannerSlider.is(':hover') && promotionalBannerCanAutoplay()) {
          $promotionalBannerSlider.slick('slickPlay');
        }
      }, 2000);
    };

    $promotionalBannerSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 0,
      speed: 500,
      cssEase: 'linear',
      dots: false,
      pauseOnHover: true,
      pauseOnFocus: false,
      arrows: true,
      draggable: true,
      swipe: true,
      touchMove: true,
      swipeToSlide: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      infinite: true,
      nextArrow: '#promotional-banner-next',
      prevArrow: '#promotional-banner-prev',
      responsive: [
        { breakpoint: 1400, settings: { slidesToShow: 3 } },
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 991, settings: { slidesToShow: 2, autoplay: true, speed: 5000, arrows: false } },
        { breakpoint: 768, settings: { slidesToShow: 2, autoplay: true, speed: 5000, arrows: false } },
        { breakpoint: 575, settings: { slidesToShow: 1.2, autoplay: true, speed: 5000, arrows: false } },
        { breakpoint: 424, settings: { slidesToShow: 1.1, autoplay: true, speed: 5000, arrows: false } },
      ]
    });

    __Main.registerSlider('.promotional-banner-slider');

    // Manual pause/resume on hover — properly calls Slick's internal methods
    $promotionalBannerSlider.on('click', '.promotional-banner-item, .promotional-banner-item a', function () {
      if (!promotionalBannerCanAutoplay()) return;
      $promotionalBannerSlider.slick('slickPause');
      resumePromotionalBannerAfterDelay();
    });
    $promotionalBannerSlider.on('mouseenter', '.promotional-banner-item', function () {
      if (!promotionalBannerCanAutoplay()) return;
      clearTimeout(promotionalBannerResumeTimer);
      $promotionalBannerSlider.slick('slickPause');
    });
    $promotionalBannerSlider.on('mouseleave', '.promotional-banner-item', function () {
      if (!promotionalBannerCanAutoplay()) return;
      $promotionalBannerSlider.slick('slickPlay');
    });
    $promotionalBannerSlider.on('mousedown touchstart swipe', function () {
      if (!promotionalBannerCanAutoplay()) return;
      $promotionalBannerSlider.slick('slickPause');
      resumePromotionalBannerAfterDelay();
    });
    // ========================= Shop By Bikes Slider Start =======================
    const $shopByBikesSlider = $('.shop-by-bikes-slider');
    if ($shopByBikesSlider.length) {
      $shopByBikesSlider.slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        dots: false,
        arrows: true,
        draggable: true,
        infinite: false,
        nextArrow: '#shop-by-bikes-next',
        prevArrow: '#shop-by-bikes-prev',
        rtl: $('html').attr('dir') === 'rtl' ? true : false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      __Main.registerSlider('.shop-by-bikes-slider');
    }
    // ========================= Shop By Bikes Slider End =======================

    // ========================= hot deals Slider Js Start ==============
    $('.product-one-slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#product-one-next',
      prevArrow: '#product-one-prev',
      responsive: [
        { breakpoint: 1699, settings: { slidesToShow: 4, arrows: false } },
        { breakpoint: 1599, settings: { slidesToShow: 4, arrows: false } },
        { breakpoint: 1499, settings: { slidesToShow: 4, arrows: false } },
        { breakpoint: 1399, settings: { slidesToShow: 4, arrows: false } },
        { breakpoint: 1299, settings: { slidesToShow: 4, arrows: false } },
        { breakpoint: 1199, settings: { slidesToShow: 4, arrows: false } },
        { breakpoint: 991, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 768, settings: { slidesToShow: 1, arrows: false, autoplay: false } },
        { breakpoint: 575, settings: { slidesToShow: 1, arrows: false, autoplay: false } },
      ]
    });
    __Main.registerSlider('.product-one-slider');
    // ========================= hot deals Slider Js End ===================

    // ========================= Banner Three Slider Js Start ==============
    $('.banner-three-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      fade: true,
      cssEase: 'linear',
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#banner-three-next',
      prevArrow: '#banner-three-prev',
    });
    __Main.registerSlider('.banner-three-slider');
    // ========================= Banner Three Slider Js End ===================

    // ========================= feature-item-wrapper Slider Js Start ==============
    $('.feature-item-wrapper').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 4000,
      cssEase: 'linear',
      dots: false,
      pauseOnHover: true,
      arrows: false,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      infinite: true,
      responsive: [
        { breakpoint: 1399, settings: { slidesToShow: 3 } },
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 575, settings: { slidesToShow: 4 } },
      ]
    });
    __Main.registerSlider('.feature-item-wrapper');
    // ========================= feature-item-wrapper Slider Js End ===================

    // ========================= feature-three-item-wrapper Slider Js Start ==============
    $('.feature-three-item-wrapper').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1000,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#feature-item-wrapper-next',
      prevArrow: '#feature-item-wrapper-prev',
      responsive: [
        { breakpoint: 1599, settings: { slidesToShow: 6 } },
        { breakpoint: 1399, settings: { slidesToShow: 4 } },
        { breakpoint: 992, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 3 } },
        { breakpoint: 575, settings: { slidesToShow: 2 } },
        { breakpoint: 424, settings: { slidesToShow: 2 } },
        { breakpoint: 359, settings: { slidesToShow: 2 } },
      ]
    });
    __Main.registerSlider('.feature-three-item-wrapper');
    // ========================= feature-three-item-wrapper Slider Js End ===================

    // ========================= Banner two Slider Js Start ==============
    $('.banner-item-two__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1500,
      dots: true,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      fade: true,
      cssEase: 'linear',
      nextArrow: '#banner-next',
      prevArrow: '#banner-prev',
      responsive: [{ breakpoint: 767, settings: { slidesToShow: 1 } }]
    });
    __Main.registerSlider('.banner-item-two__slider');
    // ========================= Banner two Slider Js End ===================

    // ========================= flash-sales Slider Js Start ==============
    $('.flash-sales__slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#flash-next',
      prevArrow: '#flash-prev',
      responsive: [{ breakpoint: 991, settings: { slidesToShow: 1, arrows: false } }]
    });
    __Main.registerSlider('.flash-sales__slider');
    // ========================= flash-sales Slider Js End ==================

    // ========================= hot-deals Slider Js Start ==============
    $('.hot-deals-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#deals-next',
      prevArrow: '#deals-prev',
      responsive: [
        { breakpoint: 1599, settings: { slidesToShow: 3 } },
        { breakpoint: 1199, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 768, settings: { slidesToShow: 1, arrows: false, autoplay: false } },
        { breakpoint: 575, settings: { slidesToShow: 1, arrows: false, autoplay: false } },
        { breakpoint: 424, settings: { slidesToShow: 1, arrows: false, autoplay: false } },
      ]
    });
    __Main.registerSlider('.hot-deals-slider');
    // ========================= hot-deals Slider Js End ===================

    // ========================= deals-week Slider Js Start ==============
    $('.deals-week-slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#deal-week-next',
      prevArrow: '#deal-week-prev',
      responsive: [
        { breakpoint: 1599, settings: { slidesToShow: 5, arrows: false } },
        { breakpoint: 1399, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 1199, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 575, settings: { slidesToShow: 1, arrows: false } },
      ]
    });
    __Main.registerSlider('.deals-week-slider');
    // ========================= deals-week Slider Js End ===================

    // ========================= top-selling-product Slider Js Start ==============
    $('.top-selling-product-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#top-selling-next',
      prevArrow: '#top-selling-prev',
      responsive: [
        { breakpoint: 1399, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 1199, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 575, settings: { slidesToShow: 1, arrows: false } },
      ]
    });
    __Main.registerSlider('.top-selling-product-slider');
    // ========================= top-selling-product Slider Js End ===================

    // ========================= organic-food Slider Js Start ==============
    $('.organic-food__slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#organic-next',
      prevArrow: '#organic-prev',
      responsive: [
        { breakpoint: 1599, settings: { slidesToShow: 6, arrows: false } },
        { breakpoint: 1399, settings: { slidesToShow: 4, arrows: false } },
        { breakpoint: 992, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 575, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 424, settings: { slidesToShow: 1, arrows: false } },
      ]
    });
    __Main.registerSlider('.organic-food__slider');
    // ========================= organic-food Slider Js End ===================

    // ========================= new-arrival Slider Js Start ==============
    $('.new-arrival__slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#new-arrival-next',
      prevArrow: '#new-arrival-prev',
      responsive: [
        { breakpoint: 1599, settings: { slidesToShow: 6, arrows: false } },
        { breakpoint: 1399, settings: { slidesToShow: 4, arrows: false } },
        { breakpoint: 992, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 575, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 424, settings: { slidesToShow: 1, arrows: false } },
      ]
    });
    __Main.registerSlider('.new-arrival__slider');
    // ========================= new-arrival Slider Js End ===================

    // ========================= short-product-list Slider Js Start ==============
    $('.short-product-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev border border-gray-100 w-30 h-30 bg-transparent rounded-pill position-absolute hover-bg-main-600 hover-text-white hover-border-main-600 transition-1"><i class="ph ph-caret-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next border border-gray-100 w-30 h-30 bg-transparent rounded-pill position-absolute hover-bg-main-600 hover-text-white hover-border-main-600 transition-1"><i class="ph ph-caret-right"></i></button>',
    });
    __Main.registerSlider('.short-product-list');
    // ========================= short-product-list Slider Js End ===================

    // ========================= Copy Coupon Code Js Start ===================
    const copyCouponBtn = document.querySelector('.copy-coupon-btn');
    const copyText = document.querySelector('.copy-text');

    if (copyCouponBtn && copyText) {
      copyText.style.display = 'none';

      const onCopyClick = function () {
        const text = this.textContent;
        navigator.clipboard.writeText(text);
        this.classList.add('copied');
        copyText.innerHTML = 'Copied';
        copyText.style.display = 'inline-block';

        setTimeout(() => {
          this.classList.remove('copied');
          copyText.style.display = 'none';
        }, 2000);
      };

      __Main.addVanillaListener(copyCouponBtn, 'click', onCopyClick);
    }
    // ========================= Copy Coupon Code Js End ===================

    // ========================= brand-slider Slider Js Start ==============
    $('.brand-slider').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#brand-next',
      prevArrow: '#brand-prev',
      responsive: [
        { breakpoint: 1599, settings: { slidesToShow: 7, arrows: false } },
        { breakpoint: 1399, settings: { slidesToShow: 6, arrows: false } },
        { breakpoint: 992, settings: { slidesToShow: 5, arrows: false } },
        { breakpoint: 575, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 424, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 359, settings: { slidesToShow: 2, arrows: false } },
      ]
    });
    __Main.registerSlider('.brand-slider');
    // ========================= brand-slider Slider Js End ===================

    // ========================= Category Two Js Start ===============================
    $('.category-two .category__button').on('click.mainjs', function () {
      $('.category-two .category__button').toggleClass('active')
      $('.responsive-dropdown.style-two').addClass('active').slideToggle(400);
    });
    // ========================= Category Two Js End ===============================

    // ========================= Featured Products Slider Js Start ==============
    $('.featured-product-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#featured-products-next',
      prevArrow: '#featured-products-prev',
      responsive: [{ breakpoint: 991, settings: { slidesToShow: 1, arrows: false } }]
    });
    __Main.registerSlider('.featured-product-slider');
    // ========================= Featured Products Slider Js End ==================

    // ========================= recommended-slider Slider Js Start ==============
    $('.recommended-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#recommended-next',
      prevArrow: '#recommended-prev',
      responsive: [
        { breakpoint: 1399, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 1199, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 575, settings: { slidesToShow: 1, arrows: false } },
      ]
    });
    __Main.registerSlider('.recommended-slider');
    // ========================= recommended-slider Slider Js End ===================

    // ========================= vendor-card list Slider Js Start ==============
    $('.vendor-card__list.style-two').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#vendor-next',
      prevArrow: '#vendor-prev',
    });
    __Main.registerSlider('.vendor-card__list.style-two');
    // ========================= vendor-card list Slider Js End ===================

    // ========================= top-brand Slider Js Start ==============
    // Replaced with GPU-accelerated CSS marquee
    // ========================= top-brand Slider Js End ===================

    // ========================= Product Details Thumbs Slider Js Start ===================
    $('.product-details__thumb-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.product-details__images-slider'
    });
    __Main.registerSlider('.product-details__thumb-slider');

    $('.product-details__images-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-details__thumb-slider',
      dots: false,
      arrows: false,
      focusOnSelect: true
    });
    __Main.registerSlider('.product-details__images-slider');
    // ========================= Product Details Thumbs Slider Js End ===================

    // ========================= Increment & Decrement Js Start ===================
    const minus = $('.quantity__minus');
    const plus = $('.quantity__plus');

    $(plus).on('click.mainjs', function () {
      const input = $(this).siblings('.quantity__input');
      let value = parseInt(input.val(), 10) || 0;
      value++;
      input.val(value);
    });

    $(minus).on('click.mainjs', function () {
      const input = $(this).siblings('.quantity__input');
      let value = parseInt(input.val(), 10) || 0;
      if (value > 1) {
        value--;
      }
      input.val(value);
    });
    // ========================= Increment & Decrement Js End ===================

    // ========================= Color List Js Start ===================
    $('.color-list__button').on('click.mainjs', function () {
      $('.color-list__button').removeClass('border-gray-900');

      if (!$(this).hasClass('border-gray-900')) {
        $(this).addClass('border-gray-900');
        $(this).removeClass('border-gray-50');
      } else {
        $(this).removeClass('border-gray-900');
        $(this).addClass('border-gray-50');
      };
    });
    // ========================= Color List Js End ===================

    // ========================== Range Slider Js Start =====================
    $(function () {
      if ($.fn.slider && $('#slider-range').length) {
        $("#slider-range").slider({
          range: true,
          min: 0,
          max: 25,
          values: [0, 25],
          slide: function (event, ui) {
            $("#amount").val("₹" + ui.values[0] + " - ₹" + ui.values[1]);
          }
        });
        $("#amount").val("₹" + $("#slider-range").slider("values", 0) +
          " - ₹" + $("#slider-range").slider("values", 1));
      }
    });
    // ========================== Range Slider Js End =====================

    // ========================== List Grid Js Start ================================
    $('.list-btn').on('click.mainjs', function () {
      $('.grid-btn').addClass('border-gray-100');
      $('.grid-btn').removeClass('border-main-600 text-white bg-main-600');
      $('.list-grid-wrapper').removeClass('list-view');

      $(this).removeClass('border-gray-100');
      $(this).addClass('border-main-600 text-white bg-main-600');
      $('.list-grid-wrapper').addClass('list-view');
    });

    $('.grid-btn').on('click.mainjs', function () {
      $('.list-btn').addClass('border-gray-100');
      $('.list-btn').removeClass('border-main-600 text-white bg-main-600');
      $('.list-grid-wrapper').removeClass('list-view');

      $(this).removeClass('border-gray-100');
      $(this).addClass('border-main-600 text-white bg-main-600');
    });
    // ========================== List Grid Js End ================================

    // ========================== Shop Sidebar Js Start ================================
    $('.sidebar-btn').on('click.mainjs', function () {
      $(this).addClass('bg-main-600 text-white');
      $('.shop-sidebar').addClass('active');
      $('.side-overlay').addClass('show');
      $('body').addClass('scroll-hide-sm');
    });

    $('.side-overlay, .shop-sidebar__close').on('click.mainjs', function () {
      $('.sidebar-btn').removeClass('bg-main-600 text-white');
      $('.shop-sidebar').removeClass('active');
      $('.side-overlay').removeClass('show');
      $('body').removeClass('scroll-hide-sm');
    });
    // ========================== Shop Sidebar Js End ================================

    // ========================== Remove Tr Js Start ================================
    $('.remove-tr-btn').on('click.mainjs', function () {
      $(this).closest('tr').addClass('d-none')
    });
    // ========================== Remove Tr Js End ================================

    // ========================== Checkout Payment Method Js Start ================================
    $('.payment-item .form-check-input:checked').closest('.payment-item').find('.payment-item__content').show();

    $('.payment-item .form-check-input').on('change.mainjs', function () {
      $('.payment-item__content').hide();
      $(this).closest('.payment-item').find('.payment-item__content').show();
    });
    // ========================== Checkout Payment Method Js End ================================

    // ================== Password Show Hide Js Start ==========
    $(".toggle-password").on('click.mainjs', function () {
      $(this).toggleClass("active");
      const input = $($(this).attr("id"));
      if (input.attr("type") == "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }
    });
    // ========================= Password Show Hide Js End ===========================

    // ========================= Background Image Js Start ===================
    $(".bg-img").css('background-image', function () {
      const bg = 'url(' + $(this).data("background-image") + ')';
      return bg;
    });
    // ========================= Background Image Js End ===================

    // ========================== Text Slide Js Start =====================
    if ($.fn.marquee) {
      $('.text-slider').marquee({
        pauseOnHover: true,
        allowCss3Support: true,
        css3easing: 'linear',
        easing: 'linear',
        delayBeforeStart: 0,
        duration: 7000,
        gap: 20,
        pauseOnCycle: false,
        startVisible: true
      });
    }
    // ========================== Text Slide Js End =====================

    // ========================== Trending Products Js Start =====================
    $('.expand-btn').on('click.mainjs', function () {
      $(this).toggleClass('bg-main-two-600 text-white');
      $(this).parent().find('.expand-icons').toggleClass('d-flex');

      if ($(this).children('i').hasClass('ph ph-plus')) {
        $(this).children('i').removeClass('ph ph-plus')
        $(this).children('i').addClass('ph ph-x')
      } else {
        $(this).children('i').removeClass('ph ph-x')
        $(this).children('i').addClass('ph ph-plus')
      }
    });

    // ========================== Trending Products Js End =====================

    // ========================== Wishlist Button Js Start =====================
    const wishlistKey = 'motoavenueWishlist';
    const escapeHtml = function (value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    const parseWishlist = function () {
      try {
        const stored = window.localStorage.getItem(wishlistKey);
        const parsed = stored ? JSON.parse(stored) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const saveWishlist = function (items) {
      try {
        window.localStorage.setItem(wishlistKey, JSON.stringify(items));
      } catch (error) {
        return;
      }

      document.dispatchEvent(new CustomEvent('moto:wishlist-updated', {
        detail: { items: items }
      }));
    };

    const hasWishlistApp = function () {
      const appDetected = Boolean(
        window._swat ||
        window.SWYM ||
        window.SwymCallbacks ||
        window.WishlistKing ||
        window.AppmateWishlist
      );

      if (appDetected) {
        window.__MOTO_WISHLIST_APP_PRESENT = true;
      }

      return appDetected;
    };

    const buildWishlistId = function (item) {
      const seed = item.handle || item.variantId || item.productId || item.url || item.title || item.image || '';
      return seed.trim().toLowerCase().replace(/\s+/g, '-');
    };

    const normalizeWishlistItem = function (item) {
      const normalized = {
        id: item.id || buildWishlistId(item),
        productId: item.productId || '',
        variantId: item.variantId || '',
        handle: item.handle || '',
        title: item.title || 'Product',
        url: item.url || '#',
        image: item.image || '',
        vendor: item.vendor || 'Moto Avenue',
        price: item.price || '',
        comparePrice: item.comparePrice || '',
        badge: item.badge || '',
        cartUrl: item.cartUrl || '#'
      };

      return normalized;
    };

    const getWishlistItems = function () {
      return parseWishlist().map(normalizeWishlistItem);
    };

    const findProductCard = function (trigger) {
      return trigger ? trigger.closest('.product-card-wrapper, .card-wrapper, .product-card') : null;
    };

    const findProductDetails = function (trigger) {
      if (!trigger) {
        return null;
      }

      return trigger.closest('.pdp-info-card, .product-details__content, [data-product-details]');
    };

    const findWishlistRow = function (trigger) {
      return trigger ? trigger.closest('.ma-wishlist-item') : null;
    };

    const getProductHandleFromPath = function () {
      const match = window.location.pathname.match(/^\/products\/([^\/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    };

    const findVariantInput = function (scope) {
      if (!scope) {
        return null;
      }

      let variantInput = scope.querySelector('input[name="id"]');
      if (variantInput) {
        return variantInput;
      }

      const form = scope.querySelector('product-form, form');
      if (form) {
        variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          return variantInput;
        }

        if (form.shadowRoot) {
          variantInput = form.shadowRoot.querySelector('input[name="id"]');
          if (variantInput) {
            return variantInput;
          }
        }
      }

      const customForm = scope.querySelector('product-form');
      if (customForm && customForm.shadowRoot) {
        return customForm.shadowRoot.querySelector('input[name="id"]');
      }

      return null;
    };

    const getProductVariantId = function (scope) {
      const variantInput = findVariantInput(scope);
      if (variantInput) {
        return variantInput.value;
      }

      return scope ? (scope.getAttribute('data-variant-id') || scope.getAttribute('data-product-id') || '') : '';
    };

    const syncPdpWishlistVariant = function (scope) {
      if (!scope) {
        return;
      }

      const variantId = getProductVariantId(scope);
      const wishlistButton = scope.querySelector('.wishlist-btn, .wishlist-btn-two, button[aria-label*="Wishlist"], button[title*="Wishlist"]');

      if (!variantId) {
        return;
      }

      scope.setAttribute('data-variant-id', variantId);

      if (wishlistButton) {
        wishlistButton.setAttribute('data-variant-id', variantId);
      }
    };

    const extractWishlistItem = function (trigger) {
      const card = findProductCard(trigger);

      if (card) {
        const titleLink = card.querySelector('.card__heading a, .title a, .title .link');
        const image = card.querySelector('.card__media img, .product-card__thumb img');
        const price = card.querySelector('.price-item--regular, .product-card__price .text-heading');
        const comparePrice = card.querySelector('.price-item--sale, .product-card__price .text-decoration-line-through, s, del');
        const vendor = card.querySelector('.card-information .caption-with-letter-spacing, .text-gray-500.text-xs');
        const badge = card.querySelector('.card__badge, .product-card__badge');
        const cartLink = card.querySelector('.product-card__cart');

        return normalizeWishlistItem({
          id: trigger.getAttribute('data-wishlist-id') || card.getAttribute('data-wishlist-id'),
          productId: trigger.getAttribute('data-shopify-product-id') || card.getAttribute('data-shopify-product-id') || '',
          variantId: trigger.getAttribute('data-variant-id') || card.getAttribute('data-variant-id') || card.getAttribute('data-product-id') || '',
          handle: trigger.getAttribute('data-product-handle') || card.getAttribute('data-product-handle') || card.getAttribute('data-wishlist-id') || '',
          title: trigger.getAttribute('data-compare-title') || (titleLink ? titleLink.textContent.trim() : ''),
          url: titleLink ? titleLink.getAttribute('href') : '#',
          image: trigger.getAttribute('data-compare-image') || (image ? (image.getAttribute('src') || image.currentSrc || '') : ''),
          vendor: trigger.getAttribute('data-compare-vendor') || card.getAttribute('data-product-vendor') || (vendor ? vendor.textContent.trim() : ''),
          price: trigger.getAttribute('data-compare-price') || (price ? price.textContent.replace(/\s+/g, ' ').trim() : ''),
          comparePrice: trigger.getAttribute('data-compare-compare-price') || (comparePrice ? comparePrice.textContent.replace(/\s+/g, ' ').trim() : ''),
          badge: badge ? badge.textContent.replace(/\s+/g, ' ').trim() : '',
          cartUrl: cartLink ? cartLink.getAttribute('href') : '#'
        });
      }

      const wishlistRow = findWishlistRow(trigger);

      if (wishlistRow) {
        const rowTitleLink = wishlistRow.querySelector('.ma-wishlist-item__body h3 a');
        const rowImage = wishlistRow.querySelector('.ma-wishlist-item__media img');
        const rowVendor = wishlistRow.querySelector('.ma-wishlist-item__vendor');
        const rowPrice = wishlistRow.querySelector('.ma-wishlist-item__price strong');
        const rowComparePrice = wishlistRow.querySelector('.ma-wishlist-item__price span');

        return normalizeWishlistItem({
          id: trigger.getAttribute('data-wishlist-id') || wishlistRow.getAttribute('data-wishlist-id'),
          title: rowTitleLink ? rowTitleLink.textContent.trim() : '',
          url: rowTitleLink ? rowTitleLink.getAttribute('href') : '#',
          image: rowImage ? (rowImage.getAttribute('src') || rowImage.currentSrc || '') : '',
          vendor: rowVendor ? rowVendor.textContent.trim() : '',
          price: rowPrice ? rowPrice.textContent.replace(/\s+/g, ' ').trim() : '',
          comparePrice: rowComparePrice ? rowComparePrice.textContent.replace(/\s+/g, ' ').trim() : ''
        });
      }

      const details = findProductDetails(trigger);

      if (!details) {
        return null;
      }

      const detailsTitle = details.querySelector('.pdp-title, h5');
      const detailsImage = document.querySelector('.pdp-gallery-main img, .product-details__thumb-slider img');
      const detailsPrice = details.querySelector('.pdp-price-current, h4');
      const detailsComparePrice = details.querySelector('.pdp-price-original, .text-decoration-line-through');
      const detailsCartLink = details.querySelector('.btn.btn-main');
      const detailsVendor = details.getAttribute('data-product-vendor') || document.querySelector('.product-details__sidebar .text-white')?.textContent || '';

      return normalizeWishlistItem({
        id: trigger.getAttribute('data-wishlist-id') || details.getAttribute('data-wishlist-id'),
        productId: trigger.getAttribute('data-shopify-product-id') || details.getAttribute('data-shopify-product-id') || '',
        variantId: getProductVariantId(details),
        handle: trigger.getAttribute('data-product-handle') || details.getAttribute('data-product-handle') || details.getAttribute('data-wishlist-id') || getProductHandleFromPath() || '',
        title: details.getAttribute('data-product-title') || (detailsTitle ? detailsTitle.textContent.trim() : ''),
        url: details.getAttribute('data-url') || window.location.pathname,
        image: detailsImage ? (detailsImage.getAttribute('src') || detailsImage.currentSrc || '') : '',
        vendor: String(detailsVendor || '').trim(),
        price: detailsPrice ? detailsPrice.textContent.replace(/\s+/g, ' ').trim() : '',
        comparePrice: detailsComparePrice ? detailsComparePrice.textContent.replace(/\s+/g, ' ').trim() : '',
        badge: '',
        cartUrl: detailsCartLink ? detailsCartLink.getAttribute('href') : '#'
      });
    };

    const setWishlistButtonState = function (button, active) {
      if (!button) {
        return;
      }

      const icon = button.querySelector('i');

      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      if (!icon) {
        const svg = button.querySelector('svg');
        if (svg) {
          svg.setAttribute('fill', active ? 'currentColor' : 'none');
        }
        return;
      }

      icon.classList.remove('ph', 'ph-bold', 'ph-fill', 'ph-heart', 'text-main-two-600');

      if (button.classList.contains('wishlist-btn-two')) {
        icon.classList.add(active ? 'ph-fill' : 'ph-bold', 'ph-heart');
      } else if (button.hasAttribute('data-wishlist-id')) {
        icon.classList.add(active ? 'ph-fill' : 'ph', 'ph-heart');
      } else {
        icon.classList.add(active ? 'ph-fill' : 'ph', 'ph-heart');
        if (active) {
          icon.classList.add('text-main-two-600');
        }
      }
    };

    const ensureWishlistButtons = function () {
      const cards = document.querySelectorAll('.product-card');

      cards.forEach(function (card) {
        if (!card.querySelector('.product-card__thumb') || card.querySelector('.wishlist-btn-two') || card.classList.contains('has-custom-actions')) {
          return;
        }

        card.classList.add('group-item');
        card.insertAdjacentHTML('afterbegin',
          '<button type="button" class="wishlist-btn-two" aria-label="Add to wishlist">' +
          '<i class="ph-fill ph-heart"></i>' +
          '</button>'
        );
      });
    };

    const syncWishlistButtons = function () {
      const items = getWishlistItems();
      const itemIds = new Set(items.map(function (item) { return item.id; }).filter(Boolean));
      const itemHandles = new Set(items.map(function (item) { return item.handle; }).filter(Boolean));
      const itemProductIds = new Set(items.map(function (item) { return item.productId; }).filter(Boolean));
      const itemVariantIds = new Set(items.map(function (item) { return item.variantId; }).filter(Boolean));

      const buttons = document.querySelectorAll('.wishlist-btn-two, .wishlist-btn, button[aria-label*="Wishlist"], button[title*="Wishlist"], button[data-wishlist-id]');

      buttons.forEach(function (button) {
        const item = extractWishlistItem(button);
        const itemId = item ? item.id : button.getAttribute('data-wishlist-id');
        const handle = item ? item.handle : (button.getAttribute('data-product-handle') || getProductHandleFromPath());
        const productId = item ? item.productId : button.getAttribute('data-shopify-product-id');
        const variantId = item ? item.variantId : button.getAttribute('data-variant-id');

        const isSaved = Boolean(
          (itemId && itemIds.has(itemId)) ||
          (handle && itemHandles.has(handle)) ||
          (productId && itemProductIds.has(productId)) ||
          (variantId && itemVariantIds.has(variantId))
        );

        setWishlistButtonState(button, isSaved);
      });
    };

    const updateWishlistCount = function () {
      const count = getWishlistItems().length;
      const counters = document.querySelectorAll('[data-wishlist-count]');

      counters.forEach(function (counter) {
        counter.textContent = count;
        counter.classList.toggle('d-none', count === 0);
      });
    };

    const ensureWishlistPageShell = function () {
      let page = document.querySelector('[data-wishlist-page]');

      if (page) {
        return page;
      }

      if (hasWishlistApp()) {
        return null;
      }

      const wishlistViewParams = new URLSearchParams(window.location.search);

      if (window.location.pathname !== '/pages/wishlist' || wishlistViewParams.get('view') === 'compare') {
        return null;
      }

      const wishlistContentHost = document.querySelector('.main-page-title + .rte') || document.querySelector('.rte');

      if (!wishlistContentHost) {
        return null;
      }

      document.body.classList.add('wishlist-page');
      wishlistContentHost.innerHTML = '' +
        '<div class="ma-wishlist" data-wishlist-page>' +
        '<div class="ma-wishlist-grid">' +
        '<section class="ma-wishlist-card ma-wishlist-list">' +
        '<div class="ma-wishlist-card__header">' +
        '<div>' +
        '<p class="ma-wishlist-eyebrow">Saved products</p>' +
        '<h2>Wishlist Items (<span data-wishlist-total>0</span>)</h2>' +
        '</div>' +
        '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost d-none" data-wishlist-clear>Clear Wishlist</button>' +
        '</div>' +
        '<div class="wishlist-page__empty ma-wishlist-empty d-none" data-wishlist-empty>' +
        '<div class="wishlist-page__empty-icon mx-auto mb-16"><i class="ph ph-heart"></i></div>' +
        '<h5 class="mb-8">Your wishlist is empty</h5>' +
        '<p class="text-gray-500 mb-20">Save products you love and compare them here before checkout.</p>' +
        '<a href="/" class="ma-wishlist-btn ma-wishlist-btn--primary">Browse Products</a>' +
        '</div>' +
        '<div class="ma-wishlist-items" data-wishlist-items></div>' +
        '</section>' +
        '<aside class="ma-wishlist-card ma-wishlist-summary">' +
        '<h4>Wishlist Summary</h4>' +
        '<div class="ma-wishlist-summary__row"><span>Saved items</span><strong data-wishlist-total>0</strong></div>' +
        '<div class="ma-wishlist-summary__row"><span>Store</span><strong>Moto Avenue</strong></div>' +
        '<p class="ma-wishlist-summary__note">Review your favorite riding essentials, then open a product to choose options and add it to cart.</p>' +
        '<a href="/" class="ma-wishlist-btn ma-wishlist-btn--primary">Continue Shopping</a>' +
        '</aside>' +
        '</div>' +
        '</div>';

      return wishlistContentHost.querySelector('[data-wishlist-page]');
    };

    const renderWishlistPage = function () {
      const page = ensureWishlistPageShell();

      if (!page) {
        return;
      }

      const items = getWishlistItems();
      const list = page.querySelector('[data-wishlist-items]');
      const emptyState = page.querySelector('[data-wishlist-empty]');
      const totals = page.querySelectorAll('[data-wishlist-total]');
      const clearButton = page.querySelector('[data-wishlist-clear]');

      totals.forEach(function (total) {
        total.textContent = items.length;
      });

      if (clearButton) {
        clearButton.classList.toggle('d-none', items.length === 0);
      }

      if (!list || !emptyState) {
        return;
      }

      if (!items.length) {
        list.innerHTML = '';
        emptyState.classList.remove('d-none');
        return;
      }

      emptyState.classList.add('d-none');
      list.innerHTML = items.map(function (item) {
        return '' +
          '<article class="ma-wishlist-item" data-wishlist-card data-wishlist-id="' + escapeHtml(item.id) + '">' +
          '<div class="ma-wishlist-item__media">' +
          '<a href="' + escapeHtml(item.url) + '">' +
          (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" />' : '') +
          '</a>' +
          '</div>' +
          '<div class="ma-wishlist-item__body">' +
          (item.badge ? '<span class="product-card__badge bg-warning-600 px-8 py-4 text-sm text-white">' + escapeHtml(item.badge) + '</span>' : '') +
          '<p class="ma-wishlist-item__vendor">' + escapeHtml(item.vendor) + '</p>' +
          '<h3><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>' +
          '<div class="ma-wishlist-item__meta">' +
          '<span><i class="ph-fill ph-storefront"></i> Saved for later</span>' +
          '</div>' +
          '</div>' +
          '<div class="ma-wishlist-item__side">' +
          '<div class="ma-wishlist-item__price">' +
          (item.comparePrice ? '<span>' + escapeHtml(item.comparePrice) + '</span>' : '') +
          (item.price ? '<strong>' + escapeHtml(item.price) + '</strong>' : '<strong>View price</strong>') +
          '</div>' +
          '<div class="ma-wishlist-item__actions">' +
          '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--primary wishlist-add-cart-btn"' + (item.variantId ? ' data-variant-id="' + escapeHtml(item.variantId) + '"' : '') + ' data-url="' + escapeHtml(item.url) + '">' +
          'Add <i class="ph ph-shopping-cart text-lg ms-1"></i>' +
          '</button>' +
          '<a href="' + escapeHtml(item.url) + '" class="ma-wishlist-btn ma-wishlist-btn--ghost ma-wishlist-btn--icon" title="View Product" aria-label="View Product"><i class="ph ph-eye text-lg"></i></a>' +
          '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost ma-wishlist-btn--icon wishlist-remove-btn" title="Remove from wishlist" aria-label="Remove" data-wishlist-id="' + escapeHtml(item.id) + '"><i class="ph ph-trash text-lg"></i></button>' +
          '</div>' +
          '</div>' +
          '</article>';
      }).join('');
    };

    const toggleWishlistItem = function (item) {
      const items = getWishlistItems();
      const existingIndex = items.findIndex(function (storedItem) {
        return (item.id && storedItem.id === item.id) ||
          (item.handle && storedItem.handle && storedItem.handle === item.handle) ||
          (item.productId && storedItem.productId && storedItem.productId === item.productId) ||
          (item.variantId && storedItem.variantId && storedItem.variantId === item.variantId);
      });

      if (existingIndex >= 0) {
        items.splice(existingIndex, 1);
      } else {
        items.unshift(item);
      }

      saveWishlist(items);
      syncWishlistButtons();
      updateWishlistCount();
      renderWishlistPage();
    };

    if (!window.__MOTO_WISHLIST_BOUND) {
      const wishlistClickHandler = function (event) {
        const addToCartBtn = event.target.closest('.wishlist-add-cart-btn');
        const removeButton = event.target.closest('.wishlist-remove-btn');
        const wishlistButton = event.target.closest('.wishlist-btn-two, .wishlist-btn, button[aria-label*="Wishlist"], button[title*="Wishlist"], button[data-wishlist-id]');
        const clearButton = event.target.closest('[data-wishlist-clear]');

        if (addToCartBtn) {
          event.preventDefault();
          const variantId = addToCartBtn.getAttribute('data-variant-id');
          const url = addToCartBtn.getAttribute('data-url');

          if (!variantId) {
            if (url && url !== '#') {
              window.location.href = url;
            }
            return;
          }

          if (!document.getElementById('ma-cart-spin-style')) {
            var spinStyle = document.createElement('style');
            spinStyle.id = 'ma-cart-spin-style';
            spinStyle.textContent = '@keyframes ma-cart-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}';
            document.head.appendChild(spinStyle);
          }

          const originalContent = addToCartBtn.innerHTML;
          addToCartBtn.disabled = true;
          addToCartBtn.innerHTML = '<span style="display:inline-block;width:14px;height:14px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:ma-cart-spin 0.8s linear infinite;vertical-align:middle;margin-right:6px;"></span> Adding...';

          const addEndpoint = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

          fetch(addEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: 1
              }]
            })
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Unable to add item');
              }
              return response.json();
            })
            .then(function () {
              addToCartBtn.classList.add('added');
              addToCartBtn.innerHTML = '<svg class="icon icon-checkmark" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 18px; height: 18px; display: inline-block; flex-shrink: 0;"><path d="M10 3L4.5 8.5L2 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

              const cartEndpoint = (window.routes && window.routes.cart_url) ? (window.routes.cart_url + '.js') : '/cart.js';
              fetch(cartEndpoint)
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  document.dispatchEvent(new CustomEvent('moto:cart-updated', { detail: { cart: cart } }));
                  const cartBadges = document.querySelectorAll('.cart-count-badge, .cart-count-bubble, [data-cart-count], .header__cart-count');
                  cartBadges.forEach(function (badge) {
                    badge.textContent = cart.item_count;
                    badge.classList.toggle('d-none', cart.item_count === 0);
                  });
                })
                .catch(function () {});

              setTimeout(function () {
                addToCartBtn.classList.remove('added');
                addToCartBtn.disabled = false;
                addToCartBtn.innerHTML = originalContent;
              }, 2000);
            })
            .catch(function () {
              if (url && url !== '#') {
                window.location.href = url;
              } else {
                addToCartBtn.disabled = false;
                addToCartBtn.innerHTML = originalContent;
              }
            });
          return;
        }

        if (clearButton) {
          event.preventDefault();
          saveWishlist([]);
          syncWishlistButtons();
          updateWishlistCount();
          renderWishlistPage();
          return;
        }

        if (removeButton && !wishlistButton) {
          event.preventDefault();
          const itemId = removeButton.getAttribute('data-wishlist-id');
          const items = getWishlistItems().filter(function (item) {
            return item.id !== itemId;
          });

          saveWishlist(items);
          syncWishlistButtons();
          updateWishlistCount();
          renderWishlistPage();
          return;
        }

        if (!wishlistButton) {
          return;
        }

        const item = extractWishlistItem(wishlistButton);

        if (!item) {
          return;
        }

        if (hasWishlistApp()) {
          window.setTimeout(function () {
            toggleWishlistItem(item);
          }, 0);
          return;
        }

        event.preventDefault();
        toggleWishlistItem(item);
      };

      __Main.addVanillaListener(document, 'click', wishlistClickHandler);
      __Main.addVanillaListener(document, 'moto:wishlist-updated', function () {
        syncWishlistButtons();
        updateWishlistCount();
        renderWishlistPage();
      });

      __Main.addVanillaListener(document, 'change', function (event) {
        const variantInput = event.target.closest('.pdp-info-card input[name="id"], [data-product-details] input[name="id"]');

        if (!variantInput) {
          return;
        }

        syncPdpWishlistVariant(variantInput.closest('.pdp-info-card, [data-product-details]'));
      });

      window.__MOTO_WISHLIST_BOUND = true;
    }

    const initializeWishlistUi = function () {
      ensureWishlistButtons();
      document.querySelectorAll('.pdp-info-card, [data-product-details]').forEach(syncPdpWishlistVariant);
      syncWishlistButtons();
      updateWishlistCount();
      renderWishlistPage();
    };

    initializeWishlistUi();

    if (!window.__MOTO_WISHLIST_OBSERVER) {
      const productGridContainer = document.querySelector('#ProductGridContainer');

      if (productGridContainer && typeof MutationObserver !== 'undefined') {
        const wishlistObserver = new MutationObserver(function () {
          initializeWishlistUi();
        });

        wishlistObserver.observe(productGridContainer, {
          childList: true,
          subtree: true
        });

        window.__MOTO_WISHLIST_OBSERVER = wishlistObserver;
      }
    }

    const currentParams = new URLSearchParams(window.location.search);
    const shopDetailsView = document.querySelector('[data-shop-details-view]');
    const wishlistInlineView = document.querySelector('[data-wishlist-inline-view]');

    if (currentParams.get('view') === 'wishlist' && shopDetailsView && wishlistInlineView) {
      shopDetailsView.classList.add('d-none');
      wishlistInlineView.classList.remove('d-none');
      renderWishlistPage();
      document.title = 'Wishlist';
    }
    // ========================== Wishlist Button Js End =====================

    // ========================== Compare Button Js Start =====================
    const compareStorageKey = 'motoavenueCompare';
    const compareTrayCollapsedKey = 'motoavenueCompareTrayCollapsed';
    const comparePageUrl = '/pages/wishlist?view=compare';
    const compareMaxItems = 4;
    const compareLimitMessage = 'You can compare a maximum of 4 products.';
    const compareFields = [
      { key: 'price', label: 'Price' },
      { key: 'comparePrice', label: 'Compare at' },
      { key: 'vendor', label: 'Brand' },
      { key: 'type', label: 'Category' },
      { key: 'availability', label: 'Availability' },
      { key: 'sku', label: 'SKU' },
      { key: 'weight', label: 'Weight' },
      { key: 'dimensions', label: 'Dimensions' },
      { key: 'origin', label: 'Country of Origin' },
      { key: 'hsCode', label: 'HS Code' }
    ];

    const getNormalizedPathname = function () {
      return window.location.pathname.replace(/\/+$/, '') || '/';
    };

    const isCompareView = function () {
      return getNormalizedPathname() === '/pages/compare' || (getNormalizedPathname() === '/pages/wishlist' && currentParams.get('view') === 'compare');
    };

    const parseCompareItems = function () {
      try {
        const stored = window.localStorage.getItem(compareStorageKey);
        const parsed = stored ? JSON.parse(stored) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const normalizeCompareItem = function (item) {
      const normalized = normalizeWishlistItem(item);

      return {
        id: normalized.id,
        productId: normalized.productId || '',
        variantId: normalized.variantId || '',
        handle: normalized.handle || '',
        title: normalized.title || 'Product',
        url: normalized.url || window.location.pathname,
        image: normalized.image || '',
        vendor: normalized.vendor || '',
        price: normalized.price || '',
        comparePrice: normalized.comparePrice || '',
        type: item.type || '',
        availability: item.availability || '',
        sku: item.sku || '',
        weight: item.weight || '',
        dimensions: item.dimensions || '',
        origin: item.origin || '',
        hsCode: item.hsCode || ''
      };
    };

    const getCompareItems = function () {
      const seen = new Set();

      return parseCompareItems().map(normalizeCompareItem).filter(function (item) {
        if (!item.id || seen.has(item.id)) {
          return false;
        }

        seen.add(item.id);
        return true;
      }).slice(0, compareMaxItems);
    };

    const saveCompareItems = function (items) {
      const uniqueItems = [];
      const seen = new Set();

      (Array.isArray(items) ? items : []).map(normalizeCompareItem).forEach(function (item) {
        if (!item.id || seen.has(item.id) || uniqueItems.length >= compareMaxItems) {
          return;
        }

        seen.add(item.id);
        uniqueItems.push(item);
      });

      try {
        window.localStorage.setItem(compareStorageKey, JSON.stringify(uniqueItems));
      } catch (error) {
        return;
      }

      document.dispatchEvent(new CustomEvent('moto:compare-updated', {
        detail: { items: uniqueItems }
      }));
    };

    const readCompareItemFromButton = function (button) {
      var baseItem = {};
      try { baseItem = extractWishlistItem(button) || {}; } catch (e) { baseItem = {}; }

      var id = button.getAttribute('data-product-handle')
        || button.getAttribute('data-shopify-product-id')
        || baseItem.id
        || '';

      if (!id) {
        return { id: '' };
      }

      var details = null;
      try { details = findProductDetails(button); } catch (e) { details = null; }

      var detailsPrice = details ? details.querySelector('.pdp-price-current') : null;
      var detailsComparePrice = details ? details.querySelector('.pdp-price-original') : null;
      var detailsImage = null;
      try { detailsImage = document.querySelector('.pdp-gallery-main img, .product-details__thumb-slider img'); } catch (e) { /* ignore */ }
      var variantId = '';
      try { variantId = details ? getProductVariantId(details) : ''; } catch (e) { variantId = ''; }

      var resolvedImage = button.getAttribute('data-compare-image')
        || baseItem.image
        || (detailsImage ? (detailsImage.getAttribute('src') || detailsImage.currentSrc || '') : '')
        || '';

      var resolvedPrice = button.getAttribute('data-compare-price')
        || baseItem.price
        || (detailsPrice ? detailsPrice.textContent.replace(/\s+/g, ' ').trim() : '')
        || '';

      var resolvedComparePrice = button.getAttribute('data-compare-compare-price')
        || baseItem.comparePrice
        || (detailsComparePrice ? detailsComparePrice.textContent.replace(/\s+/g, ' ').trim() : '')
        || '';

      return normalizeCompareItem({
        id: id,
        productId: button.getAttribute('data-shopify-product-id') || baseItem.productId || '',
        variantId: variantId || baseItem.variantId || '',
        handle: button.getAttribute('data-product-handle') || baseItem.handle || '',
        title: button.getAttribute('data-compare-title') || baseItem.title || '',
        url: button.getAttribute('data-product-url') || baseItem.url || window.location.pathname,
        image: resolvedImage,
        vendor: button.getAttribute('data-compare-vendor') || baseItem.vendor || '',
        price: resolvedPrice,
        comparePrice: resolvedComparePrice,
        type: button.getAttribute('data-compare-type') || '',
        availability: button.getAttribute('data-compare-availability') || '',
        sku: button.getAttribute('data-compare-sku') || '',
        weight: button.getAttribute('data-compare-weight') || '',
        dimensions: button.getAttribute('data-compare-dimensions') || '',
        origin: button.getAttribute('data-compare-origin') || '',
        hsCode: button.getAttribute('data-compare-hs-code') || ''
      });
    };

    const setCompareButtonState = function (button, active) {
      if (!button) {
        return;
      }

      const label = active ? 'Remove from Compare' : 'Add to Compare';

      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    };

    const syncCompareButtons = function () {
      const compareIds = new Set(getCompareItems().map(function (item) {
        return item.id;
      }));

      document.querySelectorAll('[data-compare-button]').forEach(function (button) {
        const item = readCompareItemFromButton(button);
        setCompareButtonState(button, item.id ? compareIds.has(item.id) : false);
      });
    };

    const showCompareMessage = function (message) {
      let toast = document.querySelector('[data-compare-toast]');

      if (!toast) {
        toast = document.createElement('div');
        toast.setAttribute('data-compare-toast', '');
        toast.className = 'ma-compare-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }

      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(window.__MOTO_COMPARE_TOAST_TIMER);
      window.__MOTO_COMPARE_TOAST_TIMER = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2600);
    };

    const isCompareTrayCollapsed = function () {
      try {
        return window.localStorage.getItem(compareTrayCollapsedKey) === 'true';
      } catch (error) {
        return false;
      }
    };

    const isCompareTrayMobile = function () {
      return window.matchMedia('(max-width: 991px)').matches;
    };

    const isCompareTrayMobileExpanded = function () {
      return Boolean(window.__MOTO_COMPARE_MOBILE_EXPANDED);
    };

    const setCompareTrayCollapsed = function (collapsed) {
      if (isCompareTrayMobile()) {
        return;
      }

      try {
        window.localStorage.setItem(compareTrayCollapsedKey, collapsed ? 'true' : 'false');
      } catch (error) {
        /* ignore storage failures */
      }

      renderCompareTray();
    };

    const ensureCompareDrawer = function () {
      let overlay = document.querySelector('[data-compare-drawer-overlay]');
      let drawer = document.querySelector('[data-compare-drawer]');

      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'ma-compare-drawer-overlay';
        overlay.setAttribute('data-compare-drawer-overlay', '');
        document.body.appendChild(overlay);
      }

      if (!drawer) {
        drawer = document.createElement('div');
        drawer.className = 'ma-compare-drawer';
        drawer.setAttribute('data-compare-drawer', '');
        document.body.appendChild(drawer);
      }

      return { overlay: overlay, drawer: drawer };
    };

    const openCompareDrawer = function () {
      const els = ensureCompareDrawer();
      const items = getCompareItems();

      els.drawer.innerHTML = '' +
        '<div class="ma-compare-drawer__header">' +
        '<h3>Compare Products (' + items.length + ')</h3>' +
        '<button type="button" class="ma-compare-drawer__close" data-compare-drawer-close>&times;</button>' +
        '</div>' +
        '<div class="ma-compare-drawer__body">' +
        items.map(function (item) {
          return '' +
            '<article class="ma-compare-drawer__item">' +
            '<div class="ma-compare-drawer__item-thumb">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '<span>' + escapeHtml(item.title.charAt(0) || 'P') + '</span>') +
            '</div>' +
            '<div class="ma-compare-drawer__item-info">' +
            '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
            '<strong>' + escapeHtml(item.price || 'View product') + '</strong>' +
            '</div>' +
            '<button type="button" class="ma-compare-drawer__item-remove" data-compare-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">&times;</button>' +
            '</article>';
        }).join('') +
        '</div>' +
        '<div class="ma-compare-drawer__footer">' +
        '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost" data-compare-clear>Clear All</button>' +
        '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--primary" data-compare-go>Compare</button>' +
        '</div>';

      els.overlay.classList.add('is-open');
      els.drawer.classList.add('is-open');
      document.body.classList.add('compare-drawer-open');

      els.overlay.onclick = closeCompareDrawer;
    };

    const closeCompareDrawer = function () {
      const overlay = document.querySelector('[data-compare-drawer-overlay]');
      const drawer = document.querySelector('[data-compare-drawer]');
      if (overlay) overlay.classList.remove('is-open');
      if (drawer) drawer.classList.remove('is-open');
      document.body.classList.remove('compare-drawer-open');
    };

    const ensureCompareTray = function () {
      let tray = document.querySelector('[data-compare-tray]');

      if (tray) {
        return tray;
      }

      tray = document.createElement('div');
      tray.setAttribute('data-compare-tray', '');
      tray.className = 'ma-compare-tray d-none';
      tray.innerHTML = '' +
        '<button type="button" class="ma-compare-tray__restore" data-compare-restore aria-label="Open compare bar">' +
        '<span data-compare-restore-count>0</span>' +
        '<i class="ph ph-scales"></i>' +
        '</button>' +
        '<div class="ma-compare-tray__inner">' +
        '<div class="ma-compare-tray__copy">' +
        '<p class="ma-compare-tray__eyebrow">Compare products</p>' +
        '<strong data-compare-tray-count>0 items selected</strong>' +
        '</div>' +
        '<div class="ma-compare-tray__items" data-compare-tray-items></div>' +
        '<div class="ma-compare-tray__actions">' +
        '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--primary" data-compare-go>Compare</button>' +
        '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost" data-compare-clear>Clear All</button>' +
        '<button type="button" class="ma-compare-tray__icon-btn" data-compare-minimize aria-label="Minimize compare bar"><i class="ph ph-minus"></i></button>' +
        '</div>' +
        '</div>';

      document.body.appendChild(tray);
      return tray;
    };

    const renderCompareTray = function () {
      const tray = ensureCompareTray();
      const items = getCompareItems();
      const countNode = tray.querySelector('[data-compare-tray-count]');
      const restoreCount = tray.querySelector('[data-compare-restore-count]');
      const itemsNode = tray.querySelector('[data-compare-tray-items]');
      const mobile = isCompareTrayMobile();

      tray.classList.toggle('d-none', items.length === 0);
      tray.classList.toggle('is-minimized', items.length > 0 && (mobile || isCompareTrayCollapsed()));
      tray.classList.toggle('is-mobile-compact', items.length > 0 && mobile);

      if (countNode) {
        countNode.textContent = items.length + '/' + compareMaxItems + (items.length === 1 ? ' product selected' : ' products selected');
      }

      if (restoreCount) {
        restoreCount.textContent = items.length;
      }

      if (itemsNode && !mobile) {
        itemsNode.innerHTML = items.map(function (item) {
          return '' +
            '<article class="ma-compare-tray__item">' +
            '<a href="' + escapeHtml(item.url) + '" class="ma-compare-tray__thumb" aria-label="' + escapeHtml(item.title) + '">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '<span>' + escapeHtml(item.title.charAt(0) || 'P') + '</span>') +
            '</a>' +
            '<div class="ma-compare-tray__meta">' +
            '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
            '<strong>' + escapeHtml(item.price || 'View product') + '</strong>' +
            '</div>' +
            '<button type="button" class="ma-compare-tray__remove" data-compare-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + ' from compare">&times;</button>' +
            '</article>';
        }).join('');
      }
    };

    const syncCompareCount = function () {
      const count = getCompareItems().length;
      document.querySelectorAll('[data-compare-count]').forEach(function (counter) {
        counter.textContent = count;
        counter.classList.toggle('d-none', count === 0);
      });
    };

    const syncComparePageTitle = function () {
      if (!isCompareView()) {
        return;
      }

      document.body.classList.add('compare-page');
      document.title = 'Compare Products';

      document.querySelectorAll('.shared-page-hero__title, .shared-page-hero__current, .main-page-title').forEach(function (node) {
        node.textContent = 'Compare Products';
      });
    };

    const ensureComparePageShell = function () {
      let page = document.querySelector('[data-compare-page]');

      if (page) {
        return page;
      }

      if (!isCompareView()) {
        return null;
      }

      const host = document.querySelector('.main-page-title + .rte') || document.querySelector('.page-width .rte') || document.querySelector('.rte');

      if (!host) {
        return null;
      }

      syncComparePageTitle();
      host.innerHTML = '' +
        '<section class="ma-compare-page" data-compare-page>' +
        '<div class="ma-compare-page__header">' +
        '<div>' +
        '<p class="ma-wishlist-eyebrow">Compare products</p>' +
        '<h2>Find the right fit side by side</h2>' +
        '<p class="ma-compare-page__lead">Compare pricing, availability, and core specs without jumping between tabs.</p>' +
        '</div>' +
        '<div class="ma-compare-page__controls">' +
        '<label class="ma-compare-toggle">' +
        '<input type="checkbox" data-compare-show-diff>' +
        '<span>Show differences only</span>' +
        '</label>' +
        '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost d-none" data-compare-clear>Clear Compare</button>' +
        '</div>' +
        '</div>' +
        '<div class="ma-compare-empty d-none" data-compare-empty>' +
        '<div class="wishlist-page__empty-icon mx-auto mb-16"><i class="ph ph-scales"></i></div>' +
        '<h5 class="mb-8">No products in compare yet</h5>' +
        '<p class="text-gray-500 mb-20">Open a product page, tap the compare icon, and we will line them up here for you.</p>' +
        '<a href="/collections/all" class="ma-wishlist-btn ma-wishlist-btn--primary">Browse Products</a>' +
        '</div>' +
        '<div class="ma-compare-table-wrap" data-compare-table-wrap></div>' +
        '<div class="ma-compare-mobile-cards" data-compare-mobile-cards></div>' +
        '</section>';

      return host.querySelector('[data-compare-page]');
    };

    const valuesAreSame = function (items, key) {
      const normalizedValues = items.map(function (item) {
        return String(item[key] || '').trim().toLowerCase();
      });

      return normalizedValues.every(function (value) {
        return value === normalizedValues[0];
      });
    };

    const renderComparePage = function () {
      const page = ensureComparePageShell();

      if (!page) {
        return;
      }

      const items = getCompareItems();
      const emptyState = page.querySelector('[data-compare-empty]');
      const wrap = page.querySelector('[data-compare-table-wrap]');
      const mobileCards = page.querySelector('[data-compare-mobile-cards]');
      const clearButtons = page.querySelectorAll('[data-compare-clear]');
      const diffToggle = page.querySelector('[data-compare-show-diff]');
      const showDiffOnly = Boolean(diffToggle && diffToggle.checked);

      clearButtons.forEach(function (button) {
        button.classList.toggle('d-none', items.length === 0);
      });

      if (!wrap || !emptyState) {
        return;
      }

      if (!items.length) {
        wrap.innerHTML = '';
        if (mobileCards) mobileCards.innerHTML = '';
        emptyState.classList.remove('d-none');
        return;
      }

      emptyState.classList.add('d-none');

      const visibleFields = compareFields.filter(function (field) {
        return !showDiffOnly || !valuesAreSame(items, field.key);
      });

      wrap.innerHTML = '' +
        '<div class="ma-compare-summary">' +
        '<strong>' + items.length + (items.length === 1 ? ' product' : ' products') + ' selected</strong>' +
        '<span>' + (items.length < 2 ? 'Add one more product to make the comparison more useful.' : 'Differences are easiest to scan in the highlighted rows.') + '</span>' +
        '</div>' +
        '<table class="ma-compare-table">' +
        '<thead>' +
        '<tr>' +
        '<th class="ma-compare-table__label">Product details</th>' +
        items.map(function (item) {
          return '' +
            '<th>' +
            '<article class="ma-compare-product">' +
            '<button type="button" class="ma-compare-product__remove" data-compare-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">&times;</button>' +
            '<a href="' + escapeHtml(item.url) + '" class="ma-compare-product__media">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '<span>' + escapeHtml(item.title.charAt(0) || 'P') + '</span>') +
            '</a>' +
            '<p class="ma-compare-product__vendor">' + escapeHtml(item.vendor || 'Moto Avenue') + '</p>' +
            '<h3><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>' +
            '<div class="ma-compare-product__price">' +
            (item.comparePrice ? '<span>' + escapeHtml(item.comparePrice) + '</span>' : '') +
            (item.price ? '<strong>' + escapeHtml(item.price) + '</strong>' : '<strong>View product</strong>') +
            '</div>' +
            '<div class="ma-compare-product__actions">' +
            '<a href="' + escapeHtml(item.url) + '" class="ma-wishlist-btn ma-wishlist-btn--primary">View Product</a>' +
            '</div>' +
            '</article>' +
            '</th>';
        }).join('') +
        '</tr>' +
        '</thead>' +
        '<tbody>' +
        visibleFields.map(function (field) {
          const sameRow = valuesAreSame(items, field.key);

          return '' +
            '<tr' + (sameRow ? '' : ' class="is-different"') + '>' +
            '<th scope="row" class="ma-compare-table__label">' + escapeHtml(field.label) + '</th>' +
            items.map(function (item) {
              const value = item[field.key];
              return '<td>' + (value ? escapeHtml(value) : '<span class="ma-compare-table__empty">—</span>') + '</td>';
            }).join('') +
            '</tr>';
        }).join('') +
        '</tbody>' +
        '</table>';

      if (mobileCards) {
        mobileCards.innerHTML = items.map(function (item) {
          var fieldsHtml = visibleFields.map(function (field) {
            var value = item[field.key];
            return '' +
              '<div class="ma-compare-mobile-card__row">' +
              '<span class="ma-compare-mobile-card__label">' + escapeHtml(field.label) + '</span>' +
              '<span class="ma-compare-mobile-card__value">' + (value ? escapeHtml(value) : '<span class="ma-compare-table__empty">—</span>') + '</span>' +
              '</div>';
          }).join('');

          return '' +
            '<article class="ma-compare-mobile-card">' +
            '<div class="ma-compare-mobile-card__header">' +
            '<button type="button" class="ma-compare-product__remove" data-compare-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">&times;</button>' +
            '<a href="' + escapeHtml(item.url) + '" class="ma-compare-mobile-card__media">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '<span>' + escapeHtml(item.title.charAt(0) || 'P') + '</span>') +
            '</a>' +
            '<div class="ma-compare-mobile-card__info">' +
            '<h3><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>' +
            '<p class="ma-compare-product__vendor">' + escapeHtml(item.vendor || 'Moto Avenue') + '</p>' +
            '<div class="ma-compare-product__price">' +
            (item.comparePrice ? '<span>' + escapeHtml(item.comparePrice) + '</span>' : '') +
            (item.price ? '<strong>' + escapeHtml(item.price) + '</strong>' : '<strong>View product</strong>') +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="ma-compare-mobile-card__fields">' +
            fieldsHtml +
            '</div>' +
            '<div class="ma-compare-mobile-card__actions">' +
            '<a href="' + escapeHtml(item.url) + '" class="ma-wishlist-btn ma-wishlist-btn--primary">View Product</a>' +
            '</div>' +
            '</article>';
        }).join('');
      }
    };

    const writeCompareAndRefresh = function (items) {
      saveCompareItems(items);
      syncCompareButtons();
      syncCompareCount();
      renderCompareTray();
      renderComparePage();
    };

    const toggleCompareItem = function (item) {
      const items = getCompareItems();
      const existingIndex = items.findIndex(function (storedItem) {
        return storedItem.id === item.id;
      });

      if (existingIndex >= 0) {
        items.splice(existingIndex, 1);
      } else {
        if (items.length >= compareMaxItems) {
          showCompareMessage(compareLimitMessage);
          return false;
        }

        items.unshift(item);
      }

      writeCompareAndRefresh(items);
      return true;
    };

    if (!window.__MOTO_COMPARE_BOUND) {
      const compareClickHandler = function (event) {
        var drawerClose = null;
        try { drawerClose = event.target.closest('[data-compare-drawer-close]'); } catch (e) { return; }

        if (drawerClose) {
          event.preventDefault();
          event.stopPropagation();
          closeCompareDrawer();
          return;
        }

        var restoreButton = null;
        try { restoreButton = event.target.closest('[data-compare-restore]'); } catch (e) { return; }

        if (restoreButton) {
          event.preventDefault();
          event.stopPropagation();
          if (isCompareTrayMobile()) {
            openCompareDrawer();
          } else {
            setCompareTrayCollapsed(false);
          }
          return;
        }

        var minimizeButton = null;
        try { minimizeButton = event.target.closest('[data-compare-minimize]'); } catch (e) { return; }

        if (minimizeButton) {
          event.preventDefault();
          event.stopPropagation();
          setCompareTrayCollapsed(true);
          return;
        }

        var goButton = null;
        try { goButton = event.target.closest('[data-compare-go]'); } catch (e) { return; }

        if (goButton) {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = comparePageUrl;
          return;
        }

        var clearButton = null;
        try { clearButton = event.target.closest('[data-compare-clear]'); } catch (e) { return; }

        if (clearButton) {
          event.preventDefault();
          event.stopPropagation();
          closeCompareDrawer();
          writeCompareAndRefresh([]);
          return;
        }

        var removeButton = null;
        try { removeButton = event.target.closest('[data-compare-remove]'); } catch (e) { return; }

        if (removeButton) {
          event.preventDefault();
          event.stopPropagation();
          var itemId = removeButton.getAttribute('data-compare-remove');
          writeCompareAndRefresh(getCompareItems().filter(function (item) {
            return item.id !== itemId;
          }));
          if (isCompareTrayMobile()) {
            openCompareDrawer();
          }
          return;
        }

        var compareButton = null;
        try { compareButton = event.target.closest('[data-compare-button]'); } catch (e) { return; }

        if (!compareButton) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        try {
          var item = readCompareItemFromButton(compareButton);

          if (!item || !item.id) {
            return;
          }

          toggleCompareItem(item);
        } catch (e) {
          /* silently ignore */
        }
      };

      __Main.addVanillaListener(document, 'click', compareClickHandler);
      __Main.addVanillaListener(document, 'change', function (event) {
        if (!event.target.matches('[data-compare-show-diff]')) {
          return;
        }

        renderComparePage();
      });
      __Main.addVanillaListener(document, 'moto:compare-updated', function () {
        syncCompareButtons();
        syncCompareCount();
        renderCompareTray();
        renderComparePage();
      });

      window.__MOTO_COMPARE_BOUND = true;
    }

    const compareGridContainer = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (compareGridContainer && typeof MutationObserver !== 'undefined' && !window.__MOTO_COMPARE_OBSERVER) {
      const compareObserver = new MutationObserver(function () {
        syncCompareButtons();
      });

      compareObserver.observe(compareGridContainer, {
        childList: true,
        subtree: true
      });

      window.__MOTO_COMPARE_OBSERVER = compareObserver;
    }

    const getCompareProducts = function () {
      return getCompareItems();
    };

    const addToCompare = function (product) {
      const item = normalizeCompareItem(product || {});
      const items = getCompareItems();

      if (!item.id) {
        return false;
      }

      if (items.some(function (storedItem) { return storedItem.id === item.id; })) {
        return true;
      }

      if (items.length >= compareMaxItems) {
        showCompareMessage(compareLimitMessage);
        return false;
      }

      items.unshift(item);
      writeCompareAndRefresh(items);
      return true;
    };

    const removeFromCompare = function (productId) {
      writeCompareAndRefresh(getCompareItems().filter(function (item) {
        return item.id !== productId;
      }));
    };

    const updateCompareBar = function () {
      renderCompareTray();
    };

    const toggleCompare = function (product) {
      return toggleCompareItem(normalizeCompareItem(product || {}));
    };

    const saveCompareProducts = function (items) {
      saveCompareItems(items || getCompareItems());
    };

    const compareApi = {
      getCompareProducts: getCompareProducts,
      addToCompare: addToCompare,
      removeFromCompare: removeFromCompare,
      updateCompareBar: updateCompareBar,
      toggleCompare: toggleCompare,
      saveCompareProducts: saveCompareProducts
    };

    window.MotoCompare = compareApi;
    window.getCompareProducts = compareApi.getCompareProducts;
    window.addToCompare = compareApi.addToCompare;
    window.removeFromCompare = compareApi.removeFromCompare;
    window.updateCompareBar = compareApi.updateCompareBar;
    window.toggleCompare = compareApi.toggleCompare;
    window.saveCompareProducts = compareApi.saveCompareProducts;

    syncCompareButtons();
    syncCompareCount();
    renderCompareTray();
    renderComparePage();
    // ========================== Compare Button Js End =====================

    // ========================== Cart Js Start =====================
    const cartPage = document.querySelector('[data-cart-page]');
    const localCartKey = 'motoavenueCart';

    const parseLocalCart = function () {
      try {
        const stored = window.localStorage.getItem(localCartKey);
        const parsed = stored ? JSON.parse(stored) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const saveLocalCart = function (items) {
      try {
        window.localStorage.setItem(localCartKey, JSON.stringify(items));
      } catch (error) {
        return;
      }

      document.dispatchEvent(new CustomEvent('moto:local-cart-updated', {
        detail: { items: items }
      }));
    };

    const getLocalCartItems = function () {
      return parseLocalCart().map(function (item) {
        const quantity = Math.max(Number(item.quantity) || 0, 0);
        const price = Math.max(Number(item.price) || 0, 0);

        return {
          id: item.id || '',
          title: item.title || 'Product',
          price: price,
          quantity: quantity,
          image: item.image || '',
          currency: item.currency || 'INR'
        };
      }).filter(function (item) {
        return item.id && item.quantity > 0;
      });
    };

    const createLocalCartState = function () {
      const items = getLocalCartItems();
      const itemCount = items.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);
      const totalPrice = items.reduce(function (sum, item) {
        return sum + (item.price * item.quantity);
      }, 0);
      const currency = 'INR';

      return {
        source: 'local',
        currency: currency,
        item_count: itemCount,
        items_subtotal_price: totalPrice,
        total_price: totalPrice,
        items: items.map(function (item) {
          return {
            source: 'local',
            id: item.id,
            key: item.id,
            product_title: item.title,
            title: item.title,
            image: item.image,
            quantity: item.quantity,
            final_price: item.price,
            final_line_price: item.price * item.quantity,
            variant_title: ''
          };
        })
      };
    };

    const addLocalCartItem = function (item) {
      const items = getLocalCartItems();
      const existingItem = items.find(function (storedItem) {
        return storedItem.id === item.id;
      });

      if (existingItem) {
        existingItem.quantity += item.quantity;
      } else {
        items.push({
          id: item.id,
          title: item.title,
          price: item.price,
          quantity: item.quantity,
          image: item.image,
          currency: item.currency
        });
      }

      saveLocalCart(items);

      return createLocalCartState();
    };

    const updateLocalCartLine = function (line, quantity) {
      const items = getLocalCartItems();
      const itemIndex = line - 1;

      if (itemIndex < 0 || itemIndex >= items.length) {
        return createLocalCartState();
      }

      if (quantity <= 0) {
        items.splice(itemIndex, 1);
      } else {
        items[itemIndex].quantity = quantity;
      }

      saveLocalCart(items);

      return createLocalCartState();
    };

    const clearLocalCart = function () {
      saveLocalCart([]);
      return createLocalCartState();
    };

    const formatCartMoney = function (amount) {
      const currency = 'INR';

      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency
        }).format((amount || 0) / 100);
      } catch (error) {
        return '₹' + (((amount || 0) / 100).toFixed(2));
      }
    };

    const updateCartCount = function (count) {
      const itemCount = Math.max(parseInt(count, 10) || 0, 0);

      document.querySelectorAll('[data-cart-count]').forEach(function (counter) {
        counter.textContent = itemCount;
        counter.classList.toggle('d-none', itemCount === 0);
      });
    };

    const setCartBusyState = function (active) {
      if (!cartPage) {
        return;
      }

      cartPage.classList.toggle('cart-page--busy', active);
    };

    const renderCartItems = function (cart) {
      if (!cartPage) {
        updateCartCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
        return;
      }

      const itemsBody = cartPage.querySelector('[data-cart-items]');
      const loadingState = cartPage.querySelector('[data-cart-loading]');
      const emptyState = cartPage.querySelector('[data-cart-empty]');
      const subtotalElement = cartPage.querySelector('[data-cart-subtotal]');
      const totalElement = cartPage.querySelector('[data-cart-total]');
      const itemCountElement = cartPage.querySelector('[data-cart-items-count]');
      const checkoutButtons = cartPage.querySelectorAll('[data-cart-checkout]');
      const hasItems = cart && Array.isArray(cart.items) && cart.items.length > 0;
      const currency = 'INR';

      if (loadingState) {
        loadingState.classList.add('d-none');
      }

      updateCartCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);

      if (itemCountElement) {
        itemCountElement.textContent = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      }

      if (subtotalElement) {
        subtotalElement.textContent = formatCartMoney(cart ? cart.items_subtotal_price : 0, currency);
      }

      if (totalElement) {
        totalElement.textContent = formatCartMoney(cart ? cart.total_price : 0, currency);
      }

      checkoutButtons.forEach(function (button) {
        button.classList.toggle('disabled', !hasItems);
        button.setAttribute('aria-disabled', hasItems ? 'false' : 'true');
        if (!hasItems) {
          button.setAttribute('tabindex', '-1');
        } else {
          button.removeAttribute('tabindex');
        }
      });

      if (!itemsBody) {
        return;
      }

      if (!hasItems) {
        itemsBody.innerHTML = '';
        if (emptyState) {
          emptyState.classList.remove('d-none');
        }
        return;
      }

      if (emptyState) {
        emptyState.classList.add('d-none');
      }

      itemsBody.innerHTML = cart.items.map(function (item, index) {
        const image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title) + '">' : '';
        const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="text-sm text-gray-500">' + escapeHtml(item.variant_title) + '</span>'
          : '';
        const itemSource = item.source || 'shopify';

        return '' +
          '<tr>' +
          '<td class="px-24 py-24">' +
          '<div class="d-flex align-items-center gap-16">' +
          '<div class="table-product__thumb flex-center bg-gray-50 rounded-12">' + image + '</div>' +
          '<div>' +
          '<h6 class="mb-6 cart-item__name">' + escapeHtml(item.product_title || item.title || 'Product') + '</h6>' +
          variantTitle +
          '<button type="button" class="cart-item__remove text-sm text-main-600 mt-8" data-cart-remove data-cart-source="' + itemSource + '" data-cart-line="' + (index + 1) + '">Remove</button>' +
          '</div>' +
          '</div>' +
          '</td>' +
          '<td class="px-24 py-24 text-heading fw-medium">' + formatCartMoney(item.final_price, currency) + '</td>' +
          '<td class="px-24 py-24">' +
          '<div class="border border-gray-100 rounded-pill py-9 px-16 flex-align d-inline-flex">' +
          '<button type="button" class="quantity__minus p-4 text-gray-700 hover-text-main-600 flex-center" data-cart-quantity-change data-cart-source="' + itemSource + '" data-cart-line="' + (index + 1) + '" data-cart-quantity="' + Math.max(item.quantity - 1, 0) + '">' +
          '<i class="ph ph-minus"></i>' +
          '</button>' +
          '<input type="number" min="0" class="quantity__input border-0 text-center w-32" value="' + item.quantity + '" data-cart-quantity-input data-cart-source="' + itemSource + '" data-cart-line="' + (index + 1) + '" readonly tabindex="-1" inputmode="none" onkeydown="return false;">' +
          '<button type="button" class="quantity__plus p-4 text-gray-700 hover-text-main-600 flex-center" data-cart-quantity-change data-cart-source="' + itemSource + '" data-cart-line="' + (index + 1) + '" data-cart-quantity="' + (item.quantity + 1) + '">' +
          '<i class="ph ph-plus"></i>' +
          '</button>' +
          '</div>' +
          '</td>' +
          '<td class="px-24 py-24 text-heading fw-semibold">' + formatCartMoney(item.final_line_price, currency) + '</td>' +
          '</tr>';
      }).join('');
    };

    const loadCart = function () {
      return fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        },
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load cart');
        }

        return response.json();
      });
    };

    const addShopifyCartItem = function (item) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: item.id,
            quantity: item.quantity
          }]
        })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to add item to cart');
        }

        return response.json();
      }).then(function () {
        return loadCart();
      }).then(function (cart) {
        clearLocalCart();
        renderCartItems(cart);
        document.dispatchEvent(new CustomEvent('moto:cart-updated', {
          detail: { cart: cart }
        }));
        return cart;
      });
    };

    const syncLocalCartToShopify = function () {
      const localItems = getLocalCartItems();

      if (!localItems.length) {
        return loadCart();
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: localItems.map(function (item) {
            return {
              id: item.id,
              quantity: item.quantity
            };
          })
        })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to sync cart');
        }

        return response.json();
      }).then(function () {
        clearLocalCart();
        return loadCart();
      }).then(function (cart) {
        renderCartItems(cart);
        document.dispatchEvent(new CustomEvent('moto:cart-updated', {
          detail: { cart: cart }
        }));
        return cart;
      });
    };

    const syncCartUi = function (options) {
      const config = options || {};

      if (cartPage && !config.silent) {
        const loadingState = cartPage.querySelector('[data-cart-loading]');
        const emptyState = cartPage.querySelector('[data-cart-empty]');

        setCartBusyState(true);

        if (loadingState) {
          loadingState.classList.remove('d-none');
        }

        if (emptyState) {
          emptyState.classList.add('d-none');
        }
      }

      return loadCart()
        .then(function (cart) {
          const localCart = createLocalCartState();
          const activeCart = cart && cart.item_count > 0 ? cart : localCart;

          renderCartItems(activeCart);
          document.dispatchEvent(new CustomEvent('moto:cart-updated', {
            detail: { cart: activeCart }
          }));
          return activeCart;
        })
        .catch(function () {
          const localCart = createLocalCartState();
          renderCartItems(localCart);
          return localCart;
        })
        .finally(function () {
          setCartBusyState(false);
          if (cartPage) {
            const loadingState = cartPage.querySelector('[data-cart-loading]');

            if (loadingState) {
              loadingState.classList.add('d-none');
            }
          }
        });
    };

    const updateCartLine = function (line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to update cart');
        }

        return response.json();
      }).then(function (cart) {
        renderCartItems(cart);
        document.dispatchEvent(new CustomEvent('moto:cart-updated', {
          detail: { cart: cart }
        }));
        return cart;
      });
    };

    window.MotoCart = {
      add: addShopifyCartItem,
      load: loadCart,
      render: renderCartItems,
      sync: syncCartUi
    };

    if (!window.__MOTO_CART_BOUND) {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          syncCartUi({ silent: true });
        });
      }

      __Main.addVanillaListener(document, 'submit', function (event) {
        const form = event.target;

        if (!form || form.closest('product-form')) {
          return;
        }

        const action = form.getAttribute('action') || '';
        const isCartAddForm = form.matches('.homepage-add-form') || action.indexOf('/cart/add') !== -1;

        if (!isCartAddForm) {
          return;
        }

        const variantInput = form.querySelector('[name="id"]');

        if (!variantInput || !variantInput.value) {
          return;
        }

        event.preventDefault();

        const submitButton = form.querySelector('[type="submit"]');
        const formData = new FormData(form);

        if (!formData.has('quantity')) {
          formData.append('quantity', '1');
        }

        if (submitButton) {
          // Inject keyframe once into <head> so it always works
          if (!document.getElementById('ma-cart-spin-style')) {
            var spinStyle = document.createElement('style');
            spinStyle.id = 'ma-cart-spin-style';
            spinStyle.textContent = '@keyframes ma-cart-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}';
            document.head.appendChild(spinStyle);
          }

          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');

          // Cache original html and show border spinner only (no text)
          submitButton.dataset.originalHtml = submitButton.innerHTML;
          submitButton.innerHTML = '<span style="display:inline-block;width:16px;height:16px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:ma-cart-spin 0.8s linear infinite;vertical-align:middle;flex-shrink:0;"></span>';
        }

        fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok || data.status) {
                throw new Error(data.description || data.message || 'Unable to add item to cart');
              }

              return loadCart();
            });
          })
          .then(function (cart) {
            clearLocalCart();
            renderCartItems(cart);
            document.dispatchEvent(new CustomEvent('moto:cart-updated', {
              detail: { cart: cart }
            }));

            // Visual success feedback — tick icon only, no text
            if (submitButton) {
              submitButton.classList.add('added');
              submitButton.innerHTML = '<svg class="icon icon-checkmark" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 16px; height: 16px; display: inline-block;"><path d="M10 3L4.5 8.5L2 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

              setTimeout(function () {
                submitButton.classList.remove('added');
                if (submitButton.dataset.originalHtml) {
                  submitButton.innerHTML = submitButton.dataset.originalHtml;
                }
              }, 2000);
            }
          })
          .catch(function () {
            syncCartUi({ silent: true });
          })
          .finally(function () {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
              // If it failed, restore immediately
              setTimeout(function () {
                if (!submitButton.classList.contains('added') && submitButton.dataset.originalHtml) {
                  submitButton.innerHTML = submitButton.dataset.originalHtml;
                }
              }, 10);
            }
          });
      });

      __Main.addVanillaListener(document, 'click', function (event) {
        const disabledCheckout = event.target.closest('[data-cart-checkout][aria-disabled="true"]');
        const quantityButton = event.target.closest('[data-cart-quantity-change]');
        const removeButton = event.target.closest('[data-cart-remove]');
        const addToCartButton = event.target.closest('[data-add-to-cart]');

        if (disabledCheckout) {
          event.preventDefault();
          return;
        }

        const checkoutButton = event.target.closest('[data-cart-checkout]');

        if (checkoutButton) {
          const localCart = createLocalCartState();

          if (!localCart.item_count) {
            return;
          }

          event.preventDefault();
          setCartBusyState(true);

          loadCart()
            .then(function (cart) {
              if (cart && cart.item_count > 0) {
                window.location.href = '/checkout';
                return cart;
              }

              return syncLocalCartToShopify().then(function () {
                window.location.href = '/checkout';
              });
            })
            .catch(function () {
              return syncLocalCartToShopify().then(function () {
                window.location.href = '/checkout';
              });
            })
            .finally(function () {
              setCartBusyState(false);
            });

          return;
        }

        // Skip [data-add-to-cart] buttons - handled by inline script in collection section
        if (addToCartButton) {
          return;
        }

        if (!quantityButton && !removeButton) {
          return;
        }

        event.preventDefault();

        const line = Number((quantityButton || removeButton).getAttribute('data-cart-line'));
        const quantity = removeButton ? 0 : Number(quantityButton.getAttribute('data-cart-quantity'));
        const source = (quantityButton || removeButton).getAttribute('data-cart-source') || 'shopify';

        if (!line || quantity < 0) {
          return;
        }

        setCartBusyState(true);

        const updateRequest = source === 'local'
          ? Promise.resolve(updateLocalCartLine(line, quantity)).then(function (cart) {
            renderCartItems(cart);
            return cart;
          })
          : updateCartLine(line, quantity);

        updateRequest.catch(function () {
          syncCartUi({ silent: true });
        }).finally(function () {
          setCartBusyState(false);
        });
      });

      __Main.addVanillaListener(document, 'change', function (event) {
        const quantityInput = event.target.closest('[data-cart-quantity-input]');

        if (!quantityInput) {
          return;
        }

        const line = Number(quantityInput.getAttribute('data-cart-line'));
        const quantity = Math.max(Number(quantityInput.value) || 0, 0);
        const source = quantityInput.getAttribute('data-cart-source') || 'shopify';

        setCartBusyState(true);

        const updateRequest = source === 'local'
          ? Promise.resolve(updateLocalCartLine(line, quantity)).then(function (cart) {
            renderCartItems(cart);
            return cart;
          })
          : updateCartLine(line, quantity);

        updateRequest.catch(function () {
          syncCartUi({ silent: true });
        }).finally(function () {
          setCartBusyState(false);
        });
      });

      window.addEventListener('moto:route-change', function (event) {
        if (event.detail && event.detail.routeName === 'cart') {
          syncCartUi({ silent: false });
        }
      });

      window.__MOTO_CART_BOUND = true;
    }

    syncCartUi({ silent: true });
    // ========================== Cart Js End =====================

    // ========================== Instagram Slider Js Start =====================
    $('.instagram-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#instagram-next',
      prevArrow: '#instagram-prev',
      responsive: [
        { breakpoint: 1299, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 992, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 768, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 424, settings: { slidesToShow: 1, arrows: false } },
      ]
    });
    __Main.registerSlider('.instagram-slider');
    // ========================== Instagram Slider Js End =====================

    // ========================== Testimonials Thumbs Slider Js Start =====================
    $('.testimonials-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.testimonials-thumbs-slider',
      dots: true,
      centerMode: true,
      focusOnSelect: true,
      fade: true,
      cssEase: 'linear',
      dots: false,
      arrows: false,
    });
    __Main.registerSlider('.testimonials-slider');

    $('.testimonials-thumbs-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 1500,
      dots: false,
      pauseOnHover: true,
      arrows: true,
      draggable: true,
      rtl: $('html').attr('dir') === 'rtl' ? true : false,
      speed: 900,
      infinite: true,
      nextArrow: '#testi-next',
      prevArrow: '#testi-prev',
      asNavFor: '.testimonials-slider',
      responsive: [
        { breakpoint: 1299, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 992, settings: { slidesToShow: 3, arrows: false } },
        { breakpoint: 768, settings: { slidesToShow: 2, arrows: false } },
        { breakpoint: 424, settings: { slidesToShow: 2, arrows: false } },
      ]
    });
    __Main.registerSlider('.testimonials-thumbs-slider');
    // ========================== Testimonials Thumbs Slider Js End =====================

    // ========================= Wow Js Start ===================
    if (typeof WOW === 'function') {
      new WOW().init();
    }
    // ========================= Wow Js End ===================

    // ========================= AOS Animation Js Start ===================
    if (typeof AOS === 'object' && AOS.init) {
      AOS.init({
        offset: 40,
        duration: 1000,
        once: true,
        easing: 'ease',
      });
    }
    // ========================= AOS Animation Js End ===================

    // ========================= Counter Up Js End ===================
    const counterUp = window.counterUp && window.counterUp.default;

    if (counterUp) {
      const callback = (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting && !el.classList.contains('is-visible')) {
            counterUp(el, { duration: 2000, delay: 16 });
            el.classList.add('is-visible');
          }
        });
      };

      const IO = new IntersectionObserver(callback, { threshold: 1 });

      const counterNumbers = document.querySelectorAll('.counter');
      if (counterNumbers.length > 0) {
        counterNumbers.forEach((counterNumber) => {
          IO.observe(counterNumber);
        });
      }
    }
    // ========================= Counter Up Js End ===================

    // end document ready
  });

  // ========================= Preloader Js Start =====================
  const hidePreloader = function () {
    const $preloader = $('.preloader');

    if (!$preloader.length) {
      return;
    }

    $preloader.stop(true, true).fadeOut(250);
  };

  $(window).on("load.mainjs", hidePreloader);

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    window.setTimeout(hidePreloader, 250);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(hidePreloader, 250);
    }, { once: true });
  }

  window.setTimeout(hidePreloader, 3000);
  // ========================= Preloader Js End=====================

  // ========================= Header Sticky Js Start ==============
  $(window).on('scroll.mainjs', function () {
    if ($(window).scrollTop() >= 260) {
      $('.header').addClass('fixed-header');
    } else {
      $('.header').removeClass('fixed-header');
    }
  });
  // ========================= Header Sticky Js End===================

  // expose cleanup for debugging/explicit call
  window.__Main = __Main;

})(jQuery);
